import { TkitUtils as Utils } from '@tkit/types';
import createModel, { Tction } from '@tkit/model';
import { IRootState } from '@src/types';
import { APIS, SimpleUserInfo, GroupVO, ParamsgroupsJoinsUsingGet, PointInfo } from '@src/services';
import { isValidUserInfo } from '../consts';

export interface IUserListState {
  firstLoginStatusCheck?: boolean;
  authority: null | string;
  userInfo?: SimpleUserInfo;
  userRes?: any;
  groupListModel: GroupVO[];
  baseUserPointInfo: PointInfo;
}

export const userModelState: IUserListState = {
  authority: null,
  userInfo: {},
  groupListModel: [],
  baseUserPointInfo: {}
};

export const selectUserInfo = (state: IRootState): SimpleUserInfo | undefined =>
  state.common.userInfo;

const model = createModel({
  state: userModelState,
  namespace: 'userModel',
  reducers: {
    // @params.0 state
    // @params.0 action
    // doSomething: (state, action: Tction<{ username: string }>) => {
    //   return {
    //     ...state,
    //     username: action.payload.username
    //   };
    // }
    doUser: (state, action: Tction<{ userInfo: SimpleUserInfo; userRes: any }>) => {
      const { firstLoginStatusCheck } = state;
      const newFirstLoginStatusCheck = firstLoginStatusCheck === undefined ? true : false;

      return {
        ...state,
        firstLoginStatusCheck: newFirstLoginStatusCheck,
        userRes: action.payload.userRes,
        userInfo: action.payload.userInfo
      };
    },
    clearUnreadMessages: state => {
      return {
        ...state,
        userInfo: { ...state.userInfo, unreadMessages: 0 }
      };
    },
    setGroupList: (state, action: Tction<{ groupListModel: GroupVO[] }>) => {
      return {
        ...state,
        groupListModel: action.payload.groupListModel
      };
    },
    // 设置用户积分
    setUserPoint: (state, action: Tction<PointInfo>) => {
      return {
        ...state,
        baseUserPointInfo: action.payload
      };
    }
  },
  effects: {
    // @params.0 sagaEffect
    // @params.0 action
    // *doSomethingAsync({ namespace, put }, action: Tction<{ username: string }>): Iterator<{}, any, any> {
    //   yield put({ type: `$\{namespace}/doLogin`, payload: { username: '' } });
    // }
    // *doTest({ tPut }): Iterator<{}, any, any> {
    //   yield tPut(doBreadcrumb, [{ path: '/', breadcrumbName: '2' }]);
    //   yield tPut(actions.doUserList, { name: 'nihao' });
    // },
    doUserInfo: [
      function*({ tCall, tPut, select }): Iterator<{}, any, any> {
        const userInfo = yield select(selectUserInfo);
        if (!isValidUserInfo(userInfo)) {
          // instead of call, use tCall, more types checking support
          // @todo 请切换到正式的用户信息接口
          const res: Utils.GetROA<typeof APIS.UserApi.userLoginSimpleUsingPost> = yield tCall(
            APIS.UserApi.userLoginSimpleUsingPost
          );
          if (res.result === 109) {
            // @ts-ignore
            location.href = res.loginUrl;
          }

          try {
            // @todo: 正常业务逻辑
          } catch (e) {
            // @todo: 错误逻辑
          } finally {
            yield tPut(model.actions.doUser, {
              userInfo: res.result as SimpleUserInfo,
              userRes: res
            });
          }
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    // 获取加入的圈子
    *getMyGroupsAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsgroupsJoinsUsingGet;
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsJoinsUsingGet> = yield tCall(
        APIS.GroupApi.groupsJoinsUsingGet,
        params
      );
      const { result, code } = res;

      if (code === 0 && result) {
        yield tPut(model.actions.setGroupList, {
          groupListModel: result.list || []
        });
        callback && callback();
      }
    },
    // 获取用户积分
    *getUserPointAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: { username: string };
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.PointApi.pointUsernameUsingGet> = yield tCall(
        APIS.PointApi.pointUsernameUsingGet,
        params
      );
      const { result, code } = res;

      if (code === 0 && result) {
        yield tPut(model.actions.setUserPoint, result);
        callback && callback();
      }
    }
  }
});

export default model;
